module.exports = __webpack_public_path__ + "static/media/default-certificate.8c431849.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/certificate-img/competence/default-certificate.png
// module id = 580
// module chunks = 0